// extracted by mini-css-extract-plugin
export default {"carouselItemsHeader":"CarouselItems_carouselItemsHeader__C8svE","linkContainer":"CarouselItems_linkContainer__m28Qf"};